// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c0-2";
export var aiChatCartContainerExit = "_c0-4";
export var aiChatContainerLarge = "_c0-0";
export var aiChatContainerSmall = "_c0-1";
export var aiChatIcon = "_c0-6";
export var slideInFromRight = "_c0-3";
export var slideOutToRight = "_c0-5";